import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RequestFormModalPayload, RequestFormModalSchema } from '../types';

const initialState: RequestFormModalSchema = {
  isOpen: false,
  title: null,
  description: null,
  mode: null,
  square: null,
  sizeCodeId: null,
  boxName: null,
};

const requestFormModalSlice = createSlice({
  name: 'requestFormModal',
  initialState,
  reducers: {
    openRequestModal: (state: RequestFormModalSchema, action: PayloadAction<RequestFormModalPayload>) => {
      const { title, mode, description, square, sizeCodeId, boxName } = action.payload;
      state.isOpen = true;
      state.mode = mode;
      state.title = title;
      state.description = description;
      state.square = square;
      state.sizeCodeId = sizeCodeId;
      state.boxName = boxName;
    },
    closeRequestModal: (state: RequestFormModalSchema) => {
      state.isOpen = false;
      state.mode = null;
      state.title = null;
      state.description = null;
      state.square = null;
      state.sizeCodeId = null;
      state.boxName = null;
    },
  },
});

export const { actions: requestFormModalActions, reducer: requestFormModalReducer } = requestFormModalSlice;
